// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-title[data-v-f8b8f6e2] {\n  display: inline-block;\n  font-size: 0.36rem;\n  color: #000;\n  margin-top: 0.8rem;\n}\n.header-title[data-v-f8b8f6e2]::after {\n  display: block;\n  content: \"\";\n  width: 2.2rem;\n  height: 2px;\n  background-color: #7fd8ce;\n  margin-top: 8px;\n}", ""]);
// Exports
module.exports = exports;
